import { render, staticRenderFns } from "./AnalyticsSubmissions.vue?vue&type=template&id=09fab466&scoped=true"
import script from "./AnalyticsSubmissions.vue?vue&type=script&lang=js"
export * from "./AnalyticsSubmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fab466",
  null
  
)

export default component.exports